import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const handleErrors = err => {
  if (!err.response || err.response.status === 500) {
    // break app
  }

  return err.response
}

const responseData = res => res && res.data

const requests = {
  del: url =>
    axios.delete(url)
      .catch(handleErrors)
      .then(responseData),
  get: url =>
    axios.get(url)
      .catch(handleErrors)
      .then(responseData),
  put: (url, body) =>
    axios.put(url, body)
      .catch(handleErrors)
      .then(responseData),
  post: (url, body) =>
    axios.post(url, body)
      .catch(handleErrors)
      .then(responseData)
}

const projects = {
  list: () => requests.get('/customer/listProjects')
}

const manifest = {
  background: () => requests.get('/sliderPhoto/getPhoto?id=8')
}

const work = {
  getWork: () => requests.get('/admin/GetWork')
}

export default {
  projects,
  manifest,
  work
}



// WEBPACK FOOTER //
// ./src/service.js